package com.eladfinish.bible.contest.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AboutTerumaConfig(
    @SerialName("about_teruma_text") val text: String = "",
    @SerialName("about_teruma_cta_text") val ctaText: String = "",
    @SerialName("about_teruma_url") val url: String = "",
    @SerialName("enabled") val enabled: Boolean = false,
    @SerialName("minutes") val minutes: Int = 1440,
)
